<template>
  <vue-recaptcha
    ref="captcha"
    size="invisible"
    :sitekey="sitekey"
    @verify="$emit('verify', $event)"
    @expired="$emit('expired', $event)"
    @render="$emit('render', $event)"
  >
    <slot />
  </vue-recaptcha>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  name       : 'GoogleCaptcha',
  components : {
    VueRecaptcha
  },
  props: {
    sitekey: {
      type     : String,
      required : true
    }
  },

  data() {
    return {
      captchaScriptId: '__GOOGLE_RECAPTCHA_SCRIPT'
    };
  },

  mounted() {
    this._loadRecaptcha();
  },

  methods: {
    _loadRecaptcha() {
      if (document.getElementById(this.captchaScriptId)) {
        return;
      }

      const script = document.createElement('script');
      script.id = this.captchaScriptId;
      script.src = 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=ru';
      script.async = true;
      document.head.appendChild(script);
    },

    reset() {
      this.$refs.captcha.reset();
    },

    execute() {
      this.$refs.captcha.execute();
    }
  }
};
</script>
